/**
 * @generated SignedSource<<4e2c188acd031f47508fe3d6578984c0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteScheduleInput = {
  clientMutationId?: string | null;
  scheduleId: string;
};
export type ScheduleListTabContainer_Mutation$variables = {
  input: DeleteScheduleInput;
  connections: ReadonlyArray<string>;
};
export type ScheduleListTabContainer_MutationVariables = ScheduleListTabContainer_Mutation$variables;
export type ScheduleListTabContainer_Mutation$data = {
  readonly deleteSchedule: {
    readonly deletedScheduleId: string;
  } | null;
};
export type ScheduleListTabContainer_MutationResponse = ScheduleListTabContainer_Mutation$data;
export type ScheduleListTabContainer_Mutation = {
  variables: ScheduleListTabContainer_MutationVariables;
  response: ScheduleListTabContainer_Mutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedScheduleId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ScheduleListTabContainer_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "DeleteSchedulePayload",
        "kind": "LinkedField",
        "name": "deleteSchedule",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ScheduleListTabContainer_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "DeleteSchedulePayload",
        "kind": "LinkedField",
        "name": "deleteSchedule",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteEdge",
            "key": "",
            "kind": "ScalarHandle",
            "name": "deletedScheduleId",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "445fad73f0dc8452b1a8fdfaf9ca3571",
    "id": null,
    "metadata": {},
    "name": "ScheduleListTabContainer_Mutation",
    "operationKind": "mutation",
    "text": "mutation ScheduleListTabContainer_Mutation(\n  $input: DeleteScheduleInput!\n) {\n  deleteSchedule(input: $input) {\n    deletedScheduleId\n  }\n}\n"
  }
};
})();

(node as any).hash = "51a6a9c0e13bf3cb53cb851f447f6aaf";

export default node;
